<template>
  <el-dialog
    title="Nuevos Términos y Condiciones de uso Plataforma ACCUSELLER de UNILINK"
    :visible="areTermsAndConditionsRequired"
    width="70%"
    @open="openDialog"
    @close="closeDialog"
  >
    <p style="text-align: justify;">
      Estimado Proveedor:<br><br>
      Junto con el lanzamiento de nuestra nueva funcionabilidad de Dashboard (disponible con sus mismas claves en portal.accuseller.com) y nuestra nueva marca ACUSELLER que consolida en un solo sitio la plataforma de cotizaciones y licitaciones UNILINK junto con CAT4MRO, hemos modificado nuestros términos y condiciones. <br><br>
      Te invitamos a leerlos, se encuentran en el recuadro de abajo.
    </p>
    <div id="wrapperViewer">
      <viewer :initialValue="terms.terms" height="500px" ref="vierTUI"/>
      <editor
        :options="editorOptions"
        height="500px"
        previewStyle="vertical"
        initialEditType="wysiwyg"
        ref="toastuiEditor"
        v-show="false"
      />
    </div>
    <a href="#" @click="downloadTyC">Descargar Términos y Condiciones</a>
    <div v-if="organization.requires_terms_acceptance" style="text-align: center;">
      <span>
        <input type="checkbox" v-model="acceptTerms">
        Acepto los términos y condiciones
      </span>
    </div>
    <span slot="footer" class="dialog-footer" v-if="organization.requires_terms_acceptance">
      <el-button type="primary" @click="closeDialog">Aceptar más tarde</el-button>
      <el-button type="primary" @click="acceptedTerms" :disabled="!acceptTerms">Aceptar ahora</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';
import '@toast-ui/editor/dist/toastui-editor.css';
import { Viewer, Editor } from '@toast-ui/vue-editor';
import printJS from 'print-js';
import renderHTML from '@/core/render-html';

export default {
  components: { Viewer, Editor },
  data() {
    return {
      terms: {
        terms: '',
      },
      acceptTerms: false,
      editorOptions: {
        language: 'es-ES',
        minHeight: '300px',
        usageStatistics: false,
        hideModeSwitch: true,
      },
    };
  },
  methods: {
    ...mapMutations('termsAndConditions', ['SET_TERMS_AND_CONDITIONS_REQUIRE_FLAG_FALSE']),
    ...mapActions('termsAndConditions', ['GET_TERMS_AND_CONDITION_BY_ID_OR_COUNTRY', 'setTermsAndConditionsStatusToTrue', 'setTyCStatusToTrue', 'termsAcceptedFromModal']),
    openDialog() {
      // this should call a method to modify user flag terms_and_conditions_viewed to 'Viewed'
      const role = window.localStorage.getItem('role');
      if (role.toLowerCase().includes('mro_manage_supplier')) this.setTermsAndConditionsStatusToTrue({ userID: this.currentUser['x-hasura-user-id'] });
      else this.setTyCStatusToTrue();
    },
    closeDialog() {
      this.SET_TERMS_AND_CONDITIONS_REQUIRE_FLAG_FALSE();
    },
    acceptedTerms() {
      this.termsAcceptedFromModal({ orgId: this.currentUser['x-hasura-organization-id'] });
      const variables = {
        organization_id: this.currentUser.profile.organization.id,
        terms_and_conditions_id: this.terms.id,
      };
      this.$store.dispatch('termsAndConditions/insertOrganizationAcceptedTerms', variables);
      this.$store.dispatch('termsAndConditions/alertAcceptanceTermsConditions');
      this.closeDialog();
    },
    downloadTyC() {
      const html = this.$refs.toastuiEditor.invoke('getHTML');
      const render = renderHTML({ html });
      printJS({
        type: 'raw-html',
        printable: render,
        targetStyles: ['*'],
      });
    },
  },
  computed: {
    ...mapState('termsAndConditions', ['areTermsAndConditionsRequired', 'organization', 'user']),
    ...mapState('auth', ['currentUser']),
  },
  watch: {
    async organization(org) {
      if (!org || !this.areTermsAndConditionsRequired || (this.user.terms_and_conditions_viewed && !this.organization.requires_terms_acceptance)) return;
      // If organization has specific terms and conditions
      const variables = (org.terms_and_conditions_id) ? { idTerms: org.terms_and_conditions_id, country: null, active: null } : { idTerms: null, country: org.country };
      this.terms = await this.GET_TERMS_AND_CONDITION_BY_ID_OR_COUNTRY(variables);
      this.$store.dispatch('auth/setLoadingDefaultPageToFalse');
      if (!this.$refs) return;
      if (this.$refs.vierTUI) this.$refs.vierTUI.invoke('setMarkdown', this.terms.terms);
      if (this.$refs.toastuiEditor) this.$refs.toastuiEditor.invoke('setMarkdown', this.terms.terms);
    },
  },
};
</script>

<style scoped>
div#wrapperViewer {
    padding: 1rem;
    border: 1px solid black;
    background-color: #e5e5e5;
    margin: 2rem 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/supplier/terms/TermsModal.vue